module.exports = __webpack_public_path__ + "static/img/brees-2010-img-in-copy.e1a9f5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2010-img-in-copy.jpg
// module id = YS4O
// module chunks = 1